<div *ngFor="let payment of listPayments$ | async">
    <app-payment-card-mobile  [currentPayment]="payment" [columns]="columns">
    </app-payment-card-mobile>
</div>